import React from 'react';
import { stageSkin } from '../../lib/opportunity';

export function OpportunityStageBadge({ stage }: { stage: unknown }) {
  const skin = stageSkin(stage);
  return (
    <span
      data-testid="opportunity-stage-badge"
      className={`inline-flex w-fit items-center whitespace-nowrap rounded-fi-pill border border-black/20 px-2.5 py-1 text-[0.68rem] font-black uppercase tracking-[0.06em] leading-none text-fi-signal-ink ${skin.fill}`}
    >
      {skin.label}
    </span>
  );
}

export default OpportunityStageBadge;
